import { useState } from "react";
import { useCart } from "../../context/CartContext";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function CheckoutPage() {
  const { cartItems, clearCart } = useCart();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    note: "",
    currency: "USD" 
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!form.name || !form.email || !form.phone || !form.address) {
    toast.error("Please fill all required fields");
    return;
  }

  // 🔍 Cart-д байгаа item-уудыг шалгах
  console.log("🛒 Cart items before checkout:", cartItems);

  const totalAmount = parseFloat(
    cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0)
  ).toString(); // ➜ "0.1"


  console.log("💰 totalAmount:", totalAmount);


  // 🔍 Total amount тооцоолсны дараа
  console.log("💰 totalAmount:", totalAmount);

  // if (totalAmount <= 0 || isNaN(totalAmount)) {
  //   toast.error("Төлбөрийн дүн 0 эсвэл алдаатай байна.");
  //   return;
  // }

  try {
    const orderRes = await axios.post("https://admin.bodiosyakdown.com/api/orders", {
      ...form,
      items: cartItems,
    });

    const orderId = orderRes.data.orderId;

    const res = await axios.post("https://admin.bodiosyakdown.com/api/golomt/payment", {
      amount: totalAmount.toString(),
      currency: form.currency,
      orderId: orderId,
      description: `Order #${orderId}`,
    }, {
      withCredentials: true // ← Хэрэггүй байж болно, гэхдээ CORS дээр credentials:true гэж заасан бол нэм
    });


    // 🔁 Golomt-оос redirect линк ирсэн эсэхийг шалгах
    console.log("🔁 Golomt redirect URL:", res.data.redirectUrl);

    if (res.data.success && res.data.redirectUrl) {
      window.location.href = res.data.redirectUrl;
    } else {
      toast.error("Төлбөрийн линк ирсэнгүй.");
      console.error("❌ Payment response:", res.data);
    }

  } catch (err) {
    console.error("❌ Axios error:", err);
    toast.error("Төлбөрийн холбоо амжилтгүй.");
    navigate("/cart");
  }
};






  return (
    <div className="max-w-xl mx-auto py-12 px-4 mt-20">
      <h2 className="text-3xl font-bold mb-6">Checkout</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-medium">Name*</label>
          <input type="text" name="name" value={form.name} onChange={handleChange} className="w-full border px-4 py-2 rounded" required />
        </div>

        <div>
          <label className="block font-medium">Email*</label>
          <input type="email" name="email" value={form.email} onChange={handleChange} className="w-full border px-4 py-2 rounded" required />
        </div>

        <div>
          <label className="block font-medium">Phone*</label>
          <input type="tel" name="phone" value={form.phone} onChange={handleChange} className="w-full border px-4 py-2 rounded" required />
        </div>

        <div>
          <label className="block font-medium">Address*</label>
          <textarea name="address" value={form.address} onChange={handleChange} className="w-full border px-4 py-2 rounded" required />
        </div>

        <div>
          <label className="block font-medium">Note</label>
          <textarea name="note" value={form.note} onChange={handleChange} className="w-full border px-4 py-2 rounded" />
        </div>

        <button
          type="submit"
          className="bg-black text-white w-full py-3 rounded hover:bg-gray-800"
        >
          Place Order
        </button>
      </form>
    </div>
  );
}
